import * as angular from 'angular';
import * as d3 from 'd3';

import { ComponentDefinition } from '../../models';

class SymbolDisplayController implements angular.IComponentController {
    symbol: string;
    hasSymbol: boolean;

    static $inject = ['$element'];

    constructor(private _$element: angular.IRootElementService) {
    }

    $onInit() {
        this.updateSymbol();
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['symbol']) {
            this.updateSymbol();
        }
    }

    private updateSymbol() {
        this.hasSymbol = this.isSymbol();

        if (this.hasSymbol) {
            d3.select(this._$element[0])
                .select('path')
                .attr('d', d3.svg.symbol().type(this.symbol));
        }
    }

    private isSymbol() {
        return !!this.symbol && this.symbol.toLowerCase() !== 'none';
    }
}

export const wtSymbolDisplay: ComponentDefinition = {
    componentId: 'wtSymbolDisplay',
    controller: SymbolDisplayController,
    template: require('./symbolDisplay.component.html'),
    controllerAs: 'vm',
    bindings: {
        symbol: '<'
    }
};
